export default "__VITE_ASSET__178c4d16__"